import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const saveResolutionDecisions = api(async function saveResolutionDecisions({ id, decisions }) {
    return mutate(
        gql`
            mutation SaveResolutionDecisions($id: ID!, $decisions: JSON!) {
                saveResolutionDecisions(id: $id, decisions: $decisions)
            }
        `,
        { id, decisions },
        { returns: "saveResolutionDecisions" }
    )
})
